/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Audio_Extraction_Complete_ToastInputs */

const en_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio extraction completed successfully.`)
};

const fr_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction audio terminee avec succes.`)
};

const de_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Audioextraktion wurde erfolgreich abgeschlossen.`)
};

const it_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione audio completata con successo.`)
};

const ru_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение аудиофайлов успешно завершено.`)
};

const es_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción de audio completada exitosamente.`)
};

const zh_cn2_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频提取成功。`)
};

const ja_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ抽出が正常に完了しました。`)
};

const hi_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो निष्कर्षण सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_load_project_file_audio_extraction_complete_toast = /** @type {(inputs: Load_Project_File_Audio_Extraction_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração de áudio concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Audio extraction completed successfully." |
*
* @param {Load_Project_File_Audio_Extraction_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_audio_extraction_complete_toast = /** @type {((inputs?: Load_Project_File_Audio_Extraction_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Audio_Extraction_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "de") return de_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "it") return it_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "ru") return ru_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "es") return es_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "ja") return ja_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "hi") return hi_load_project_file_audio_extraction_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_audio_extraction_complete_toast(inputs)
	return en_load_project_file_audio_extraction_complete_toast(inputs)
});